module.exports = __webpack_public_path__ + "static/media/harina_estandar.1f9887f9.png";